export const LANGUAGE_KEY_MAPPING = {
	en: 'en-US',
	zh: 'zh-CN',
	th: 'th-TH'
};
